import InvoiceView from 'src/pages/Invoice/Invoice.view'

export default InvoiceView;
